import Typography from '@mui/material/Typography';
import { Box } from '@mui/material';
import { ITag } from 'services/api/entities';
import { Song } from 'services/store/songs/types';
import getMoodString from 'services/helpers/song/getSongMoods';
import useStyles from './style';

type PropsType = {
  song: Song | null;
};

const SongMoodItems = ({ song }: PropsType) => {
  const classes = useStyles();

  if (!song || !('moods' in song)) {
    return null;
  }

  return (
    <Box className={classes.mood}>
      {song?.moods?.map((mood: ITag, index: number) => {
        if (index > 1) return null;

        return (
          <Typography
            key={mood.id}
            data-testid={`songTagChips-${mood.name}-${index}`}
            color="textSecondary"
            title={mood.name}
            variant="body1"
            style={{
              wordWrap: 'break-word',
              cursor: 'default',
              whiteSpace: 'pre',
            }}
          >
            {getMoodString(mood.name, index, song.moods.length)}
          </Typography>
        );
      })}
    </Box>
  );
};

export default SongMoodItems;
